// extracted by mini-css-extract-plugin
export default {"subBalance":"EarningsCard_subBalance__aV3jK","loaderContainer":"EarningsCard_loaderContainer__gxGjd","loader":"EarningsCard_loader__39M7e"};